export class StatusClass {

  public static OnFilterApplied(input: string, itemType?: string) {
    itemType = angular.isDefined(itemType)
      ? '-' + itemType
      : '';

    if (StatusClass.isNeutralState(input)) {
      return 'neutral' + itemType;
    }
    if (StatusClass.isPositiveState(input)) {
      return 'positive' + itemType;
    }

    if (StatusClass.isExpiredState(input)) {
      return 'expired' + itemType;
    }

    if (StatusClass.isUnavailableState(input)) {
      return 'notavailable' + itemType;
    }
    return 'negative' + itemType;
  }

  public static isNeutralState(input) {
    const neutralStates = ['MEDIUM', 'AWAITING_AUTHORISATION', 'AWAITING', 'PENDING_APPROVAL', 'UPLOADING', 'PENDING', 'PENDING_VERIFICATION', 'PENDING_REVERIFICATION', 'IN_PROGRESS', 'OPEN', 'INCOMPLETE', 'HELD', 'DISTRIBUTED', 'PROCESSING', 'CANCELLED', 'VOIDED', 'CONSTRUCTED', 'REFUNDED'];
    return _.includes(neutralStates, input);
  }

  public static isPositiveState(input) {
    const positiveStates = ['LOW', 'AUTHORISED', 'LIVE', 'VALID', 'ACTIVE', 'COMPLETE', 'UPLOADED', 'SUCCESSFUL', 'SUCCESS', 'CURRENT', 'DELAYED', 'SETTLED', 'APPROVED', 'CLOSED', 'ACCEPTED'];
    return _.includes(positiveStates, input);
  }

  public static isExpiredState(input) {
    const expiredStates = ['INVALID', 'DRAFT', 'EXPIRED', 'REPLACED', 'NOT_UPLOADED'];
    return _.includes(expiredStates, input);
  }

  public static isUnavailableState(input) {
    const unavailableStates = ['NONE', 'NOT_AVAILABLE'];
    return _.includes(unavailableStates, input);
  }
}
